import { useState, useRef } from "react";
import { getLocalAuth } from "../../utils/AuthUtils";
import { baseUrl } from "../../constants/Constant";
import { updateProfile } from "../../resources/UserResource";
import { showSuccessToast } from "../../utils/GlobalToast";

function Profile() {
    const values = getLocalAuth()
    const profile = JSON.parse(values.authLocal);
    const [name, setName] = useState(profile.data.name);
    const [username, setUsername] = useState(profile.data.username);
    const [email, setEmail] = useState(profile.data.email);
    const [password, setPassword] = useState("");

    const refEdit = useRef(null);

    const [isErrorEdit, setIsErrorEdit] = useState(false);
    const [errorEdit, setErrorEdit] = useState("");

    const [isLoading, setIsLoading] = useState(false);

    const [selectedImage, setSelectedImage] = useState(null);
    const [defaultImage, setDefaultImage] = useState(profile.data.image);

    const handleEdit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (selectedImage === null) {
            fetch(`${baseUrl}/${defaultImage}`)
                .then((res) => res.blob())
                .then(async (myBlob) => {
                    const myFile = new File([myBlob], 'image.jpeg', { type: myBlob.type });
                    await updateProfile(profile.data.id, name, email, password, myFile).then((res) => {
                        setIsLoading(false);
                        setIsErrorEdit(false);
                        showSuccessToast("Success Updated Profile!");
                        setPassword("");
                        setSelectedImage(null);
                        setDefaultImage("");
                        if (refEdit.current) {
                            refEdit.current.value = "";
                            refEdit.current.type = "text";
                            refEdit.current.type = "file";
                        }
                        window.location.reload();
                    }).catch((err) => {
                        setIsLoading(false);
                        setErrorEdit(err);
                        setIsErrorEdit(true);
                    });
                }).catch((err) => {
                    setIsLoading(false);
                    setErrorEdit(err);
                    setIsErrorEdit(true);
                });
        } else {
            updateProfile(profile.data.id, name, email, password, selectedImage).then((res) => {
                setIsLoading(false);
                setIsErrorEdit(false);
                showSuccessToast("Success Updated Profile!");
                setSelectedImage(null);
                setDefaultImage("");
                if (refEdit.current) {
                    refEdit.current.value = "";
                    refEdit.current.type = "text";
                    refEdit.current.type = "file";
                }
                window.location.reload();
            }).catch((err) => {
                setIsLoading(false);
                setErrorEdit(err);
                setIsErrorEdit(true);
            });
        }
    }

    const handleImgLoadingError = (e) => {
        // default image add, if associated image is not available...
        e.target.src = '../assets/images/default-profile.png';
    };

    return (
        <div className="page-content-wrapper">
            <div className="page-content">
                {isErrorEdit ? <div style={{ paddingLeft: '16px', paddingRight: '16px', paddingTop: '16px', paddingBottom: '0px' }}>
                    <div className="alert alert-danger alert-dismissible fade show" role="alert">{errorEdit}
                        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setIsErrorEdit(false)}></button>
                    </div>
                </div> : null}
                <div className="user-profile-page">
                    <div className="card radius-15">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-12 col-lg-7 border-right">
                                    <div className="d-md-flex align-items-start">
                                        <div className="mb-md-0 mb-3">
                                            <img src={`${baseUrl}/${profile.data.image}`}
                                                alt="user avatar"
                                                onError={handleImgLoadingError}
                                                className="rounded-circle shadow"
                                                width="75"
                                                height="75" />
                                        </div>
                                        <div className="ms-md-4 flex-grow-1">
                                            <div className="d-flex align-items-center mb-1">
                                                <h4 className="mb-0">{profile.data.name}</h4>
                                            </div>
                                            <p className="mb-0 text-muted">{profile.data.email}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-5">
                                    <table className="table table-sm table-borderless mt-md-0 mt-3">
                                        <tbody>
                                            <tr>
                                                <th>Privilege:</th>
                                                <td>{profile.data.privilege === null ? '-' : profile.data.privilege.name === null ? '-' : profile.data.privilege.name}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Departement:</th>
                                                <td>{profile.data.department === null ? '-' : profile.data.department.name === null ? '-' : profile.data.department.name}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="row align-items-center">
                                <div className="col">
                                    <ul className="nav nav-pills mt-4">
                                        <li className="nav-item"> <a className="nav-link active" data-bs-toggle="tab" href="#Edit-Profile"><span className="p-tab-name">Detail Profile</span><i className='bx bx-message-edit font-24 d-sm-none'></i></a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-auto">

                                </div>
                            </div>
                            <div className="tab-content mt-3">
                                <div className="tab-pane fade show active" id="Edit-Profile">
                                    <div className="card shadow-none border mb-0 radius-15">
                                        <div className="card-body">
                                            <div className="form-body">
                                                <form onSubmit={handleEdit}>
                                                    <div className="row">
                                                        <div className="col-12 col-lg-6">
                                                            <div className="col-12 mb-3">
                                                                <label className="form-label fw-bold">Name</label>
                                                                <input required type="text" value={name} onChange={(e) => setName(e.target.value)} className="form-control" />
                                                            </div>
                                                            <div className="col-12 mb-3">
                                                                <label className="form-label fw-bold">Username</label>
                                                                <input required disabled type="text" value={username} onChange={(e) => setUsername(e.target.value)} className="form-control" />
                                                            </div>
                                                            <div className="col-12 mb-3">
                                                                <label className="form-label fw-bold">Image</label>
                                                                <div className="row">
                                                                    <div className="col-auto">
                                                                        <div className="product-img bg-transparent border">
                                                                            <img src={selectedImage === null ? `${baseUrl}/${defaultImage}` : URL.createObjectURL(selectedImage)} width="35" height="35" alt="" />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col">
                                                                        <input className="form-control" type="file" id="formFile" accept="image/png, image/jpeg" onChange={(e) =>
                                                                            setSelectedImage(e.target.files[0])
                                                                        } ref={refEdit} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-lg-6">
                                                            <div className="col-12 mb-3">
                                                                <label className="form-label fw-bold">Password</label>
                                                                <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="form-control" />
                                                            </div>
                                                            <div className="col-12 mb-3">
                                                                <label className="form-label fw-bold">Email</label>
                                                                <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} className="form-control" />
                                                            </div>
                                                            <div className="col-12 mb-3">
                                                                <div className="row">
                                                                    <div className="col"></div>
                                                                    <div className="col-auto">
                                                                        {!isLoading ? <button type="submit" className="btn btn-info ms-auto mt-4">Save Change</button> : <button className="btn btn-info mt-4" type="button" disabled> <span style={{ marginRight: '4px' }} className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                            Loading...</button>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Profile;